var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeepAlive',[_c('div',{staticClass:"m-0 p-0"},[_c('div',{staticClass:"sumo-browse-main"},[_c('section',_vm._l((_vm.smartCollections),function(item,index){return _c('smart-collection',{key:item.id,attrs:{"collection":item,"use-intersection":index >= _vm.maxCollectionServerFetch}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }